/**
 * GeneratorsMapPage
 * Fullscreen map page for displaying generators
 */

import React, { useEffect } from 'react';
import { GeneratorsMap } from '@/components/features/generators/GeneratorsMap';
import { useLayoutConfig } from '@/components/common/ProtectedLayout';

export const GeneratorsMapPage: React.FC = () => {
  const { setNoPadding } = useLayoutConfig();

  // Set no padding for fullscreen map
  useEffect(() => {
    setNoPadding(true);
    return () => setNoPadding(false);
  }, [setNoPadding]);

  return <GeneratorsMap />;
};
